/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import dayjs from 'dayjs';

export const thousandSeparator = (value: string, separator: string) => {
  value = '' + value;
  separator = separator || ' ';
  let result = '',
    temp = 0;
  while (value.match(/^0[0-9]/)) {
    value = value.substr(1);
  }
  for (let i = value.length - 1; i >= 0; i--) {
    result =
      temp !== 0 && temp % 3 === 0
        ? value[i] + separator + result
        : value[i] + result;
    temp++;
  }
  return result;
};

export const stringToDate = (date: string) => {
  const dateParts = date.split('/');
  const result = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);

  return result;
};

export const stringHourToDate = (date: string) => {
  const dateParts = date.split(':');
  const result = new Date();
  result.setHours(+dateParts[0], +dateParts[1], 0);
  return result;
};

const addZero = (i: number) => {
  return i < 10 ? '0' + i : i;
};

export const DateToHHmmFormat = (date: Date) => {
  const h = addZero(date.getHours());
  const m = addZero(date.getMinutes());

  return `${h}:${m}`;
};

export const DateToddmmyyyyFormat = (date: Date, type: string = '') => {
  const _date = new Date();
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
};

export const DateToddmmyyyyFormatNoError = (date: Date, type: string = '') => {
  const _date = new Date();
  const year = date.getFullYear();
  const month = (1 + date.getMonth()).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${day}/${month}/${year}`;
};

export const dateDdMmYyToMmDdYy = (value: string, separator: string) => {
  const dateArray = value.split(separator);
  let result = '';
  if (dateArray[1]) {
    result = dateArray[1] + separator + dateArray[0] + separator + dateArray[2];
  }

  return result;
};

export const handleGetCurrentDateEffet = (dateEffet: any) => {
  if (dayjs(dateEffet).isValid()) {
    return dayjs(dateEffet).format('DD/MM/YYYY');
  } else {
    return dayjs().format('DD/MM/YYYY');
  }
};
